import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type {
  BreederUpdateReviewMutation,
  BreederUpdateReviewMutationVariables,
} from '@gql/graphql';
import { useCallback } from 'react';
import { BREEDER_REVIEW_GET_REVIEWS } from './useGetReviews';

export const BREEDER_UPDATE_REVIEW = graphql(`
  mutation BreederUpdateReview($data: DogBreederReviewUpdateInput!, $reviewId: Int!) {
    updateDogBreederReview(data: $data, reviewId: $reviewId) {
      id
    }
  }
`);

export const useUpdateReview = () => {
  const [updateDogBreederReview, { error, loading }] = useMutation<
    BreederUpdateReviewMutation,
    BreederUpdateReviewMutationVariables
  >(BREEDER_UPDATE_REVIEW, {
    refetchQueries: [BREEDER_REVIEW_GET_REVIEWS],
  });

  const answerReview = useCallback(
    (reviewId: number, content: string) => {
      return updateDogBreederReview({
        variables: { reviewId, data: { answer: { create: { content } } } },
      });
    },
    [updateDogBreederReview],
  );
  const editReviewAnswer = useCallback(
    (reviewId: number, content: string) => {
      return updateDogBreederReview({
        variables: {
          reviewId,
          data: {
            answer: { update: { data: { content: { set: content } } } },
          },
        },
      });
    },
    [updateDogBreederReview],
  );

  return {
    updateDogBreederReviewLoading: loading,
    updateDogBreederReviewError: error,
    answerReview,
    editReviewAnswer,
  };
};
